import React from "react";
import { IListing } from "repoV2/features/Listing/Listing.interfaces";
import {
    CUSTOM_QUESTION_TYPES,
    CUSTOM_QUESTION_TYPES_ID,
} from "../../../../../../../repoV2/utils/getInTouchForm/getInTouchForm.constants";
import styles from "../../userDetails.module.scss";
import { ICustomQuestions } from "./ICustomQuestions";

const CustomQuestions = ({
    data,
    answers = {},
    setAnswers,
    thumbnails,
    setThumbnails,
    showError,
    uploadSubfolder,
}: ICustomQuestions.IProps): JSX.Element => {
    // Get HTML ID for the element. Useful for testing automation
    const getID = (indexProp: number): string =>
        `userInfo-answers-${indexProp}`;

    return (
        <>
            {data?.map((item: IListing.IQuestion, index: number) => {
                if (!CUSTOM_QUESTION_TYPES[item.type]) return null;
                const userInput = answers?.[item.uuid];
                const showInputError = !!(showError && item.is_mandatory);

                const commonProps: ICustomQuestions.IBaseFieldProps = {
                    htmlId: getID(index),
                    item,
                    showInputError,
                    userInput,
                    answers,
                    setAnswers,
                    thumbnails,
                    setThumbnails,
                };

                if (item.type === CUSTOM_QUESTION_TYPES_ID.FILE) {
                    commonProps.subFolder = uploadSubfolder;
                    commonProps.usedIn = "userDetailsModal";
                }
                // eslint-disable-next-line no-lone-blocks

                return (
                    <div key={item.uuid} className={styles.formField}>
                        <div
                            className={styles.formTitle}
                            title={`This field is ${
                                item.is_mandatory ? "mandatory" : "optional"
                            }`}
                        >
                            {item.question}
                            {item.is_mandatory ? (
                                <span className={styles.mandatory}>
                                    &nbsp;*
                                </span>
                            ) : null}
                        </div>
                        {CUSTOM_QUESTION_TYPES[item.type].renderQuestion(
                            commonProps
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default CustomQuestions;
